// import React, { useState } from 'react';
// import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, IconButton, keyframes } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import CloseIcon from '@mui/icons-material/Close';
// import HomeIcon from '@mui/icons-material/Home';
// import InfoIcon from '@mui/icons-material/Info';
// import ContactMailIcon from '@mui/icons-material/ContactMail';
// import { useSelector } from 'react-redux';
// import api from '../../api/axiosInterceptor';
// import DropdownComponent from '../menuSlider/menuSlider';
// import { AdminRoleManagementComponent } from '../../Pages/adminMgmt/adminUserRoleManagement';
// import FeMenuDropdownComponent from '../feMenuSlider/feMenuSlider';
// import ClaimListPage from '../../Pages/claimMaster/claimList';
// import ClaimVer1List from '../../Pages/claimMaster/claimOfficerMgmt/claimVer1List';
// import ClaimVer2List from '../../Pages/claimMaster/claimOfficerMgmt/claimVer2List';
// import ClaimCAList from '../../Pages/claimMaster/claimOfficerMgmt/claimCAList';
// import ClaimCANSttldList from '../../Pages/claimMaster/claimOfficerMgmt/claimNotSttledList';
// import ClaimDashboard from '../../Pages/claimMaster/claimDshboard/userClaimDashboard';
// import FEVerifierClaimsSummary from '../../Pages/claimMaster/claimDshboard/ver1Dashboard';
// import FEClaimsStatusVer2 from '../../Pages/claimMaster/claimDshboard/ver2ClaimDashboard';
// import FECAClaimsCACounts from '../../Pages/claimMaster/claimDshboard/caClaimDashboard';
// import { LegalTemplateComponent } from '../../Pages/HomePages/legalTemplate';
// import SuperStaffDropdownComponent from '../menuSlider/superStaffMenuSlider';
// import StaffDropdownComponent from '../menuSlider/staffMenuSlider';

// const drawerWidth = 240;
// const headerHeight = 210;

// // Keyframe for pulsing glow
// const pulse = keyframes`
//   0% { transform: scale(1); box-shadow: 0 0 0px rgba(25,118,210, 0.6); }
//   50% { transform: scale(1.1); box-shadow: 0 0 12px rgba(25,118,210, 0.8); }
//   100% { transform: scale(1); box-shadow: 0 0 0px rgba(25,118,210, 0.6); }
// `;

// export default function LeftSideMenuPage() {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [pageContent, setPageContent] = useState('Home');
//   const [protectedData, setProtectedData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [clickEffect, setClickEffect] = useState(false);

//   const role = useSelector(state => state.auth.role);
//   const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

//   const allMenuItems = [
//     { text: 'User Dashboard', icon: <HomeIcon />, rolesAllowed: ['user'] },
//     { text: 'Claim Management', icon: <HomeIcon />, rolesAllowed: ['user'] },
//     { text: 'Verifier1 Dashboard', icon: <HomeIcon />, rolesAllowed: ['verifier1'] },
//     { text: 'Verifier2 Dashboard', icon: <HomeIcon />, rolesAllowed: ['verifier2'] },
//     { text: 'CA Dashboard', icon: <HomeIcon />, rolesAllowed: ['competent_authority'] },
//     { text: 'Verifier1(claim mgmt)', icon: <ContactMailIcon />, rolesAllowed: ['verifier1'] },
//     { text: 'Verifier2(claim mgmt)', icon: <ContactMailIcon />, rolesAllowed: ['verifier2'] },
//     { text: 'CA(claim mgmt)', icon: <ContactMailIcon />, rolesAllowed: ['competent_authority'] },
//     { text: 'Claim Settlement Mgmt', icon: <ContactMailIcon />, rolesAllowed: ['competent_authority'] },
//     { text: 'Admin mgmt', icon: <InfoIcon />, rolesAllowed: ['admin'] },
//     { text: 'FE mgmt', icon: <InfoIcon />, rolesAllowed: ['admin'] },
//     { text: 'User mgmt', icon: <ContactMailIcon />, rolesAllowed: ['admin'] },
//     // staff
//     { text: 'Staff Dashboard', icon: <InfoIcon />, rolesAllowed: ['staff'] },
//      { text: 'Reference Template', icon: <InfoIcon />, rolesAllowed: ['staff', 'competent_authority'] },


//     // super staff
//     {text: 'Super Staff mgmt', icon: <ContactMailIcon />, rolesAllowed: ["super_staff"] },
//   ];

//   const menuItems = allMenuItems.filter(item => item.rolesAllowed.includes(role));

//   const toggleDrawer = () => {
//     setClickEffect(true); // trigger click animation
//     setTimeout(() => setClickEffect(false), 250); // reset after short delay
//     setDrawerOpen(!drawerOpen);
//   };

//   // to do like profile api
//   const fetchProtectedData = async () => {
//     setLoading(true);
//     try {
//       const response = await api.get('/auth/profile/');
//       setProtectedData(response.data);
//       console.log(protectedData)
//     } catch (error) {
//       console.error('Error fetching protected data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };


   
//   const drawer = (
//     <div>
//       <Box
//         sx={{
//           position: 'relative',
//           height: 48,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'flex-end',
//           px: 1
//         }}
//       >
//         <IconButton
//           onClick={toggleDrawer}
//           aria-label="close drawer"
//           sx={{
//             transition: 'transform 0.25s ease, color 0.25s ease',
//             '&:hover': {
//               transform: 'rotate(90deg) scale(1.2)',
//               color: '#d32f2f'
//             }
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </Box>
//       <List sx={{ py: 0 }}>
//         {menuItems.map(({ text, icon }) => (
//           <ListItem
//             button
//             key={text}
//             onClick={() => {
//               setPageContent(text);
//               setDrawerOpen(false);
//               fetchProtectedData();
//             }}
//           >
//             <ListItemIcon>{icon}</ListItemIcon>
//             <ListItemText primary={text} />
//           </ListItem>
//         ))}
//       </List>
//     </div>
//   );

//   const renderPageContent = () => {
//     switch (pageContent) {
//       case 'Home':
//         return <Typography sx={{ mt: 0, mb: 1 }}>Welcome to the Home Page.</Typography>;

//       case 'Admin mgmt':
//         return (
//           <Box>
//             <DropdownComponent />
//           </Box>
//         );

//       case 'User mgmt':
//         return (
//           <Box><AdminRoleManagementComponent/></Box>
//         );

//       case 'FE mgmt':
//         return (
//           <Box><FeMenuDropdownComponent/></Box>
//         );

//       case 'Claim Management':
//         return (
//           <Box><ClaimListPage/></Box>
//         );

//       case 'Verifier1(claim mgmt)':
//         return (
//           <ClaimVer1List/>
//         );

//       case 'Verifier2(claim mgmt)':
//         return (
//           <ClaimVer2List/>
//         );
//       case 'CA(claim mgmt)':
//         return (
//           <ClaimCAList/>
//         );

//       case 'Claim Settlement Mgmt':
//         return (
//           <ClaimCANSttldList/>
//         );

//         case 'User Dashboard':
//         return (
//           <ClaimDashboard/>
//         );

//         case 'Verifier1 Dashboard':
//         return (
//          <FEVerifierClaimsSummary/>
//         );

//         case 'Verifier2 Dashboard':
//         return (
//           <FEClaimsStatusVer2/>
//         );

//         case 'CA Dashboard':
//         return (
//           <FECAClaimsCACounts/>
//         );


//         // staff
//         case 'Staff Dashboard':
//         return (
//           <StaffDropdownComponent/>
//         );

//          case 'Reference Template':
//         return (
//           <LegalTemplateComponent/>
//         );

//         case 'Super Staff mgmt':
//         return ( 
//           <SuperStaffDropdownComponent/>
//         );
        

//       default:
//         return null;
//     }
//   };

//   return (
//     <Box sx={{ mt: 0, mb: 0, position: 'relative' }}>
//       {!drawerOpen && (
//         <IconButton
//           color="inherit"
//           onClick={toggleDrawer}
//           sx={{
//             position: 'fixed',
//             top: headerHeight + 16,
//             left: 16,
//             zIndex: 1400,
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             transform: clickEffect ? 'scale(0.85)' : 'scale(1)',
//             transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.3s',
//             animation: `${pulse} 1.8s infinite ease-in-out`,  
//             '&:hover': {
//               backgroundColor: '#1565c0',
//               transform: clickEffect ? 'scale(0.85)' : 'scale(1.15) rotate(10deg)',
//             }
//           }}
//           aria-label="open drawer"
//         >
//           <MenuIcon />
//         </IconButton>
//       )}

//       <Drawer
//         variant="persistent"
//         open={drawerOpen}
//         sx={{
//           '& .MuiDrawer-paper': {
//             width: drawerWidth,
//             boxSizing: 'border-box',
//             top: headerHeight,
//           }
//         }}
//       >
//         {drawer}
//       </Drawer>

//       <Box
//         component="main"
//         sx={{
//           p: 3,
//           marginTop: 10,
//           marginLeft: drawerOpen ? `${drawerWidth}px` : 0,
//           transition: 'margin-left 0.3s',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'flex-start',
//           minHeight: '50vh',
//         }}
//       >
//         {renderPageContent()}
//       </Box>
//     </Box>
//   );
// }



import React, { useState, useEffect } from 'react';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, IconButton, keyframes } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { useSelector } from 'react-redux';
import api from '../../api/axiosInterceptor';
import DropdownComponent from '../menuSlider/menuSlider';
import { AdminRoleManagementComponent } from '../../Pages/adminMgmt/adminUserRoleManagement';
import FeMenuDropdownComponent from '../feMenuSlider/feMenuSlider';
import ClaimListPage from '../../Pages/claimMaster/claimList';
import ClaimVer1List from '../../Pages/claimMaster/claimOfficerMgmt/claimVer1List';
import ClaimVer2List from '../../Pages/claimMaster/claimOfficerMgmt/claimVer2List';
import ClaimCAList from '../../Pages/claimMaster/claimOfficerMgmt/claimCAList';
import ClaimCANSttldList from '../../Pages/claimMaster/claimOfficerMgmt/claimNotSttledList';
import ClaimDashboard from '../../Pages/claimMaster/claimDshboard/userClaimDashboard';
import FEVerifierClaimsSummary from '../../Pages/claimMaster/claimDshboard/ver1Dashboard';
import FEClaimsStatusVer2 from '../../Pages/claimMaster/claimDshboard/ver2ClaimDashboard';
import FECAClaimsCACounts from '../../Pages/claimMaster/claimDshboard/caClaimDashboard';
import { LegalTemplateComponent } from '../../Pages/HomePages/legalTemplate';
import SuperStaffDropdownComponent from '../menuSlider/superStaffMenuSlider';
import StaffDropdownComponent from '../menuSlider/staffMenuSlider';
import { UserGrievanceComponent } from '../../Pages/grievance/userGrievance';
import { ACOfficerGrievanceComponent } from '../../Pages/grievance/ac/acComplainsMgmt';
import { JSOfficerGrievanceComponent } from '../../Pages/grievance/js/jsComplainsMgmt';
import { SplocaOfficerGrievanceComponent } from '../../Pages/grievance/sploca/splocaComplaintMgmt';
import { MatterManagementComponent } from '../../Pages/legalApp/matter';
import FEClaimsDashboard from '../../Pages/claimMaster/claimDshboard/Reports/CaReports';
import SplocaFEClaimsDashboard from '../../Pages/claimMaster/claimDshboard/Reports/splocaReport';
import { AdminLegecyMasterComponent } from '../../Pages/adminMgmt/feAdminMgmt/adminLegecy';
// import { AdminExcessMasterComponent } from '../../Pages/adminMgmt/adminExcessPaymentMgmt/adminExcessMaster';
// import { ExcessMasterStaffComponent } from '../../Pages/adminMgmt/adminExcessPaymentMgmt/staffExcessMaster';
// import SplocaDashboardComponent from '../../Pages/adminMgmt/adminExcessPaymentMgmt/splocaEpmsDashboard';
// import CaDashboardComponent from '../../Pages/adminMgmt/adminExcessPaymentMgmt/caEpmsDashboard';
import { MovableItemsComponent } from '../../Pages/eValueM/movableEvalueM';
import ChatApplication from '../../Pages/quickchat/quickChatMaster';
import { Description } from '@mui/icons-material';
import { FormsManagementComponent } from '../../Pages/legalApp/formsMgmt/formManagementComponent';
import FinancialEstablishmentDetail from '../../Pages/adminMgmt/feAdminMgmt/feMasterSploca';
import RoleWorkflowTabs from '../../Pages/adminMgmt/adminExcessPaymentMgmt/roleWorkFlowTabs';
import ActivityLogsComponent from '../../Pages/account/activityLogs';

const drawerWidth = 240;
const headerHeight = 210;

// Keyframe for pulsing glow
const pulse = keyframes`
  0% { transform: scale(1); box-shadow: 0 0 0px rgba(25,118,210, 0.6); }
  50% { transform: scale(1.1); box-shadow: 0 0 12px rgba(25,118,210, 0.8); }
  100% { transform: scale(1); box-shadow: 0 0 0px rgba(25,118,210, 0.6); }
`;

export default function LeftSideMenuPage() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [pageContent, setPageContent] = useState('Home');
  const [protectedData, setProtectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clickEffect, setClickEffect] = useState(false);

  const role = useSelector(state => state.auth.role);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  const allMenuItems = [
    { text: 'Dashboard', icon: <HomeIcon />, rolesAllowed: ['user'] },
    { text: 'Claim Management', icon: <HomeIcon />, rolesAllowed: ['user'] },
    { text: 'Grievance & Suggestion', icon: <ContactMailIcon />, rolesAllowed: ['user'] },
    { text: 'Verifier1 Dashboard', icon: <HomeIcon />, rolesAllowed: ['verifier1'] },
    { text: 'Verifier2 Dashboard', icon: <HomeIcon />, rolesAllowed: ['verifier2'] },
    { text: 'CA Dashboard', icon: <HomeIcon />, rolesAllowed: ['competent_authority'] },
    { text: 'Verifier1(claim mgmt)', icon: <ContactMailIcon />, rolesAllowed: ['verifier1'] },
    { text: 'Verifier2(claim mgmt)', icon: <ContactMailIcon />, rolesAllowed: ['verifier2'] },
    { text: 'CA(claim mgmt)', icon: <ContactMailIcon />, rolesAllowed: ['competent_authority'] },
    { text: 'Claim Settlement Mgmt', icon: <ContactMailIcon />, rolesAllowed: ['competent_authority'] },
    {text: 'Reports', icon: <ContactMailIcon />, rolesAllowed: ['competent_authority'] },
    { text: 'Admin mgmt', icon: <InfoIcon />, rolesAllowed: ['admin'] },
    { text: 'FE DB & Coding', icon: <InfoIcon />, rolesAllowed: ['admin'] },
    { text: 'User mgmt', icon: <ContactMailIcon />, rolesAllowed: ['admin'] },
    { text: 'Staff Dashboard', icon: <InfoIcon />, rolesAllowed: ['staff'] },
    { text: 'Reference Template', icon: <InfoIcon />, rolesAllowed: ['staff', 'competent_authority'] },
    { text: 'Super Staff mgmt', icon: <ContactMailIcon />, rolesAllowed: ['super_staff'] },
    { text: 'Report Dashboard', icon: <ContactMailIcon />, rolesAllowed: ['sploca'] },
    { text: 'FE Legecy Data', icon: <ContactMailIcon />, rolesAllowed: ['competent_authority', 'verifier1', 'verifier2', 'sploca'] },
    { text: 'FE Database & Coding', icon: <InfoIcon />, rolesAllowed: ['sploca'] },
    
    // grievance mgmt
    { text: 'Grievance Mgmt', icon: <ContactMailIcon />, rolesAllowed: ['assistant_commissioner'] },
    { text: 'Grievance mgmt', icon: <ContactMailIcon />, rolesAllowed: ['joint_secretary'] },
    { text: 'Grievance Management', icon: <ContactMailIcon />, rolesAllowed: ['sploca'] },


    // legal
    { text: 'Matter Mgmt', icon: <ContactMailIcon />, rolesAllowed: ['legal', 'sploca', 'competent_authority', 'admin'] },

    // // excess payment mgmt
    // { text: 'Excess Payment Admin Mgmt', icon: <ContactMailIcon />, rolesAllowed: ['admin'] },
    // { text: 'Excess Payment officers Mgmt', icon: <ContactMailIcon />, rolesAllowed: ['super_staff', "staff", "shirastedar"] },
    // { text: 'EPMS Dashboard', icon: <ContactMailIcon />, rolesAllowed: ['admin', 'sploca'] },
    // { text: 'CA EPMS Dashboard', icon: <ContactMailIcon />, rolesAllowed: ['competent_authority'] },

    // excess payment mgmt
    {
      text: 'Excess Payment Mgmt (EPMS)',
      icon: <ContactMailIcon />,
      // component: RoleWorkflowTabs,
      rolesAllowed: [
        'admin',
        'super_staff', 'staff',           // → Case Worker tabs
        'shirastedar',
        'tahsildar',
        'assistant_commissioner',
        'forensic_auditor',
        'competent_authority',
        'sploca',
        'joint_secretary'
      ],
    },

    // ChatApplication
    { text: 'Quick Chat', icon: <ContactMailIcon />, rolesAllowed: ['user', 'verifier1', 'verifier2', 'competent_authority', 'staff', 'super_staff', 'admin'] },


    // evalueM
    { text: 'eValueM', icon: <ContactMailIcon />, rolesAllowed: ['admin'] },

    // Logs
    { text: 'Activity Logs', icon: <ContactMailIcon />, rolesAllowed: ['admin', 'sploca'] },

    // legal forms
    {
  text: 'Forms Management',
  icon: <Description />,
  rolesAllowed: [
  'super_staff', 'shirastedar', 'tahsildar',
    'legal', 'assistant_commissioner', 'joint_secretary',
    'competent_authority', 'admin', 'sploca',"forensic_auditor"
  ],
},
  ];

  const menuItems = allMenuItems.filter(item => item.rolesAllowed.includes(role));

  const toggleDrawer = () => {
    setClickEffect(true); // trigger click animation
    setTimeout(() => setClickEffect(false), 250); // reset after short delay
    setDrawerOpen(!drawerOpen);
  };

  // Fetch protected data, triggers API call that can refresh token on 401
  // const fetchProtectedData = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await api.get('/');
  //     setProtectedData(response.data);
  //     console.log(response.data);
  //   } catch (error) {
  //     console.error('Error fetching protected data:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Trigger fetchProtectedData on page refresh/component mount to refresh token
  // useEffect(() => {
  //   fetchProtectedData();
  // }, []);

  const drawer = (
    <div>
      <Box
        sx={{
          position: 'relative',
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: 1
        }}
      >
        <IconButton
          onClick={toggleDrawer}
          aria-label="close drawer"
          sx={{
            transition: 'transform 0.25s ease, color 0.25s ease',
            '&:hover': {
              transform: 'rotate(90deg) scale(1.2)',
              color: '#d32f2f'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <List sx={{ py: 0 , mb:30}}>
        {menuItems.map(({ text, icon }) => (
          <ListItem
            button
            key={text}
            onClick={() => {
              setPageContent(text);
              setDrawerOpen(false);
              // fetchProtectedData();
            }}
          >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const renderPageContent = () => {
    switch (pageContent) {
      case 'Home':
        return <Typography sx={{ mt: 0, mb: 1 }}>Welcome to the Home Page.</Typography>;

      case 'Admin mgmt':
        return (
          <Box>
            <DropdownComponent />
          </Box>
        );

      case 'User mgmt':
        return (
          <Box><AdminRoleManagementComponent /></Box>
        );

      case 'FE DB & Coding':
        return (
          <Box><FeMenuDropdownComponent /></Box>
        );


      case 'Claim Management':
        return (
          <Box><ClaimListPage /></Box>
        );

      case 'Grievance & Suggestion':
        return (
          <Box><UserGrievanceComponent /></Box>
        );


      case 'Verifier1(claim mgmt)':
        return (
          <ClaimVer1List />
        );

      case 'Verifier2(claim mgmt)':
        return (
          <ClaimVer2List />
        );

      case 'CA(claim mgmt)':
        return (
          <ClaimCAList />
        );

      case 'Claim Settlement Mgmt':
        return (
          <ClaimCANSttldList />
        );

      case 'Dashboard':
        return (
          <ClaimDashboard />
        );

      case 'Verifier1 Dashboard':
        return (
          <FEVerifierClaimsSummary />
        );

      case 'Verifier2 Dashboard':
        return (
          <FEClaimsStatusVer2 />
        );

      case 'CA Dashboard':
        return (
          <FECAClaimsCACounts />
        );

      case 'Staff Dashboard':
        return (
          <StaffDropdownComponent />
        );

      case 'Reference Template':
        return (
          <LegalTemplateComponent />
        );

      case 'Super Staff mgmt':
        return (
          <SuperStaffDropdownComponent />
        );
      


        case 'Grievance Mgmt':
        return (
          <ACOfficerGrievanceComponent />
        );

        case 'Grievance mgmt':
        return (
          <JSOfficerGrievanceComponent />
        );

        case 'Grievance Management':
        return (
          <SplocaOfficerGrievanceComponent />
        );
        
        case 'Matter Mgmt':
        return (
          <MatterManagementComponent />
        );

        case 'Reports':
        return (
          <FEClaimsDashboard/>
        );

        case 'Report Dashboard':
        return (
          <SplocaFEClaimsDashboard />
        );

        case 'FE Legecy Data':
        return (
          <AdminLegecyMasterComponent />
        );

        // case 'Excess Payment Admin Mgmt':
        // return (
        //   <AdminExcessMasterComponent/>
        // );

        // case 'Excess Payment officers Mgmt':
        // return (
        //   <ExcessMasterStaffComponent/>
        // );

        // case 'EPMS Dashboard':
        // return (
        //   <SplocaDashboardComponent/>
        // );

        // case 'CA EPMS Dashboard':
        // return (
        //   <CaDashboardComponent/>
        // );

        case 'Excess Payment Mgmt (EPMS)':
        return (
          <RoleWorkflowTabs/>
        );

        case 'eValueM':
        return (
          <MovableItemsComponent/>
        );
        case 'FE Database & Coding':
            return (
              <Box><FinancialEstablishmentDetail /></Box>
            );

        case 'Quick Chat':
        return (
         <ChatApplication/>
        );
 
        case 'Forms Management':
          return <FormsManagementComponent />;

        case "Activity Logs":
          return <ActivityLogsComponent />;

      default:
        return null;
    }
  };

  return (
    <Box sx={{ mt: 0, mb: 0, position: 'relative' }}>
      {!drawerOpen && (
        <IconButton
          color="inherit"
          onClick={toggleDrawer}
          sx={{
            position: 'fixed',
            top: headerHeight + 16,
            left: 16,
            zIndex: 1400,
            backgroundColor: '#1976d2',
            color: '#fff',
            transform: clickEffect ? 'scale(0.85)' : 'scale(1)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.3s',
            animation: `${pulse} 1.8s infinite ease-in-out`,
            '&:hover': {
              backgroundColor: '#1565c0',
              transform: clickEffect ? 'scale(0.85)' : 'scale(1.15) rotate(10deg)',
            }
          }}
          aria-label="open drawer"
        >
          <MenuIcon />
        </IconButton>
      )}

      <Drawer
        variant="persistent"
        open={drawerOpen}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            top: headerHeight,
          }
        }}
      >
        {drawer}
      </Drawer>

      <Box
        component="main"
        sx={{
          p: 3,
          marginTop: 10,
          marginLeft: drawerOpen ? `${drawerWidth}px` : 0,
          transition: 'margin-left 0.3s',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          minHeight: '50vh',
        }}
      >
        {renderPageContent()}
      </Box>
    </Box>
  );
}
